import React, { useEffect } from 'react'
import DataTable from '../../components/datatable'
import { useState } from 'react'
import {
  payrollHistoryStatusConfig,
  PAGINATION_DEFAULT,
} from '../../utils/constants'
import { useGetBasicPayslip } from '../../redux/payroll/hook/index'
import html2pdf from 'html2pdf.js/dist/html2pdf.min'
import ReactDOMServer from 'react-dom/server'
import { useSelector } from 'react-redux'
import { toDataUrl } from '../../utils/functions'
import BasicPayslipPDFContent from '../../utils/pdf-content/basic-payslip'
import BasicPayrollDetailedView from '../../components/modal/payroll/basic-payroll-full-view'

const BasicPayslip = () => {
  useEffect(() => {
    window.scroll(0, 0)
  }, [])

  const { company } = useSelector((state) => state.companySlice)

  const [pagination, setPagination] = useState({
    limit: PAGINATION_DEFAULT.limit,
    page: PAGINATION_DEFAULT.page,
    statusFilter: PAGINATION_DEFAULT.statusFilter,
    search: '',
    start_date: '',
    end_date: '',
  })

  const [showpayslipHistoryDetailedView, setShowpayslipHistoryDetailedView] =
    useState(false)
  const [previewData, setPreviewData] = useState()
  const [imageBlob, setImageBlob] = useState(null)
  const [downloadPayslipLoading, setDownloadPayslipLoading] = useState(false)

  // const changeImage = async (imageLink) => {
  //   let urlBase64 = await toDataUrl(imageLink);
  //   setImageBlob(urlBase64)
  // }

  const changeImage = async (imageLink) => {
    if (!imageLink) {
      console.log('No image link provided')
      return
    }
    try {
      const urlBase64 = await toDataUrl(imageLink)
      setImageBlob(urlBase64)
    } catch (err) {
      console.error('Error in changeImage:', err)
    }
  }

  useEffect(() => {
    if (company) {
      changeImage(company.logo)
    }
    return setImageBlob(null)
  }, [company])

  const printHandler = (index) => {
    setDownloadPayslipLoading(true)
    const printElement = ReactDOMServer.renderToString(
      BasicPayslipPDFContent(company, payslipHistory.data[index], imageBlob)
    )
    var opt = {
      margin: 0,
      filename: payslipHistory.data[index]?.ref + ' - basic payslip.pdf',
      image: { type: '', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      pagebreak: { mode: 'avoid-all', before: '#page2el' },
      jsPDF: { unit: 'in', format: 'a4', orientation: 'portrait' },
      enableLinks: true,
    }
    html2pdf().set(opt).from(printElement).save()
    setDownloadPayslipLoading(false)
  }

  const { data: payslipHistory } = useGetBasicPayslip(
    pagination?.limit,
    pagination?.page,
    pagination?.statusFilter
  )

  const tableConfig = {
    headers: ['Employee name', 'Bank Info', 'Description', 'Status', 'Net Pay'],
    keys: [
      'employee_name',
      'bank_info',
      'description',
      'status',
      'formatted_net_pay',
    ],
    mobileHeader: {
      left: {
        title: 'Description',
        key: 'description',
      },
      right: {
        title: 'Net Pay',
        key: 'formatted_net_pay',
      },
    },
  }

  const statusConfig = [
    {
      label: 'Not Processed',
      color: 'orange',
      value: 0,
    },
    {
      label: 'Processed',
      color: 'green',
      value: 1,
    },
  ]

  const actionConfig = [
    {
      name: 'View',
      color: 'green',
      action: async (id) => {
        let index = payslipHistory.data.findIndex((item) => item.id === id)
        setPreviewData(payslipHistory.data[index])
        setShowpayslipHistoryDetailedView(true)
      },
    },
    {
      name: 'Download Payslip',
      color: 'red',
      action: (id) => {
        let index = payslipHistory.data.findIndex((item) => item.id === id)
        if (index !== -1) {
          printHandler(index)
        }
      },
    },
  ]

  return (
    <>
      {previewData && showpayslipHistoryDetailedView ? (
        <BasicPayrollDetailedView
          isOpen={showpayslipHistoryDetailedView}
          closeModal={() => setShowpayslipHistoryDetailedView(false)}
          viewData={previewData}
          previewType={'view'}
        />
      ) : null}
      <div className='flex flex-col bg-white shadow-md rounded-md'>
        <hr className='divider mt-2 mb-2' />
        <DataTable
          data={payslipHistory}
          noCheck={true}
          tableConfig={tableConfig}
          filterByStatus={payrollHistoryStatusConfig}
          statusConfig={statusConfig}
          actionConfig={actionConfig}
          updatePagination={(data) => setPagination(data)}
          searchData={true}
          computedActions={true}
        />
      </div>
    </>
  )
}

export default BasicPayslip
